const vapidKey = 'BC6bf8zZ5J1ek7ZF_ARIWPvLNLHfeqyF-ZzSF59eJ5ay6x6kjYusl5vlentv6Ypzf7-ftfY79VTGR8DV9Yx85_A'

const firebaseConfig = {
  apiKey: 'AIzaSyDAjTcQbU6xTLU8J8PR9JOuPA5Zx2C-A3o',
  authDomain: 'ltv-slldt.firebaseapp.com',
  projectId: 'ltv-slldt',
  storageBucket: 'ltv-slldt.firebasestorage.app',
  messagingSenderId: '828720140105',
  appId: '1:828720140105:web:4c139193010822caf8d498',
  measurementId: 'G-BF64PSHFP7'
}

export { vapidKey, firebaseConfig }
